/**
 * @generated SignedSource<<d7f0a65505c4db903d324ee0d0e84fb2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type popupArticle20ShareMenuContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleShareWidgetArticle">;
  readonly " $fragmentType": "popupArticle20ShareMenuContent";
};
export type popupArticle20ShareMenuContent$key = {
  readonly " $data"?: popupArticle20ShareMenuContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"popupArticle20ShareMenuContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "popupArticle20ShareMenuContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleShareWidgetArticle"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "17ad91ff560983d823f1cd8fbc6cfc94";

export default node;
